export default {
  goods: '商品',
  info: '商品信息',
  price: '价格',

  authInfo: '授权信息',

  empty: '暂无商品',
  selectGoods: '请选择商品',
}